import React, {useEffect, useState} from 'react';
import {Breadcrumb, Layout, Menu} from 'antd';
import {AppstoreOutlined, CodeOutlined, DeploymentUnitOutlined, TeamOutlined,} from '@ant-design/icons';
import {BrowserRouter as Router, Link, Navigate, Route, Routes, useLocation} from 'react-router-dom';
import PartnerPage from './pages/PartnerPage';
import SchemaPage from './pages/SchemaPage';
import MethodPage from './pages/MethodPage';
import FlowPage from './pages/SchemaMethodPage';
import {ToastProvider} from "./ToastProvider";
import AppHeader from "./AppHeader";
import LoginForm from "./components/LoginForm";
import { jwtDecode } from 'jwt-decode';

const {  Sider, Content, Footer } = Layout;

const breadcrumbNameMap = {
    '/partners': 'Đối tác',
    '/schemas': 'Schema',
    '/methods': 'Phương thức',
    '/flows': 'Luồng xử lý',
};

const AppContent = () => {
    const location = useLocation();
    const pathSnippets = location.pathname.split('/').filter(i => i);
    const extraBreadcrumbItems = pathSnippets.map((_, index) => {
        const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
        return (
            <Breadcrumb.Item key={url}>
                {breadcrumbNameMap[url] || url}
            </Breadcrumb.Item>
        );
    });

    const breadcrumbItems = [
        <Breadcrumb.Item key="home">Trang chủ</Breadcrumb.Item>,
        ...extraBreadcrumbItems,
    ];

    return (
        <Layout>
            <AppHeader />

            <Content style={{ margin: '24px 16px', background: '#fff', padding: 24 }}>
                <Breadcrumb style={{ marginBottom: 16 }}>
                    {breadcrumbItems}
                </Breadcrumb>

                <Routes>
                    <Route path="/" element={<Navigate to="/partners" replace />} />
                    <Route path="/partners" element={<PartnerPage />} />
                    <Route path="/schemas" element={<SchemaPage />} />
                    <Route path="/methods" element={<MethodPage />} />
                    <Route path="/flows" element={<FlowPage />} />
                </Routes>
            </Content>

            <Footer style={{ textAlign: 'center' }}>
                ©2025 VDG Integration Admin
            </Footer>
        </Layout>
    );
};

export default function AppLayout() {
    const [user, setUser] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            try {
                debugger;
                const decoded = jwtDecode(token);
                const isExpired = decoded.exp < Date.now()/1000;

                if (isExpired) {
                    // Token hết hạn
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('userName');
                    setUser(null);
                } else {
                    // Token còn hạn
                    setUser({ username: localStorage.getItem('userName') });
                }
            } catch (e) {
                // Token sai format
                localStorage.removeItem('accessToken');
                setUser(null);
            }
        }
    }, []);

    return<ToastProvider>{user ? (
        <Router>
            <Layout style={{minHeight: '100vh'}}>
                <Sider breakpoint="lg" collapsedWidth="80">
                    <div style={{height: 64, margin: 10, textAlign: 'center'}}>
                        <img
                            src="./logo.svg"
                            alt="VDG Logo"
                            style={{height: '100%', objectFit: 'contain'}}
                        />
                    </div>
                    <Menu theme="dark" mode="inline" defaultSelectedKeys={['partners']}>
                        <Menu.Item key="partners" icon={<TeamOutlined/>}>
                            <Link to="/partners">Đối tác</Link>
                        </Menu.Item>
                        <Menu.Item key="schemas" icon={<CodeOutlined/>}>
                            <Link to="/schemas">Schema</Link>
                        </Menu.Item>
                        <Menu.Item key="methods" icon={<DeploymentUnitOutlined/>}>
                            <Link to="/methods">Method</Link>
                        </Menu.Item>
                        <Menu.Item key="flows" icon={<AppstoreOutlined/>}>
                            <Link to="/flows">Luồng xử lý</Link>
                        </Menu.Item>
                    </Menu>
                </Sider>

                <AppContent/>
            </Layout>
        </Router>
    ) : (
        <LoginForm onLogin={(data) => setUser(data)}/>
    )}
    </ToastProvider>
}
